import { createSlice, current } from '@reduxjs/toolkit';
import {
	getInstallationLocationList,
	getInstallationLocation,
	addNewInstallationLocation,
	updateInstallationLocation,
	deleteInstallationLocation,
	checkInstallationLocationExists,
} from './thunk';

export const initialState = {
	itemInstallationLocationList: [],
	itemInstallationLocation: null,
	isInstallationLocationLoading: false,
	isInstallationLocationSuccess: false,
	dataInstallationLocation: null,
	statementList: [],
	statementListSelect: [],
	isLoadingList: false,
	isAdding: false,
	isAdded: false,
	isAddError: false,
	isUpdating: false,
	isUpdated: false,
	isUpdateError: false,
	isDeleting: false,
	isDeleted: false,
	isDeleteError: false,
	requireCloseModal: false,
	registerDisabled: false,
	requireReloadSelectionItemsGrid: false,
	exists: false,
};

const InstallationLocationSlice = createSlice({
	name: 'InstallationLocation',
	initialState,
	reducers: {
		setRequireCloseModal(state, action) {
			state.requireCloseModal = action.payload;
		},
	},
	extraReducers: builder => {
		builder.addCase(getInstallationLocationList.pending, state => {
			state.isLoadingList = true;
			state.isInstallationLocationSuccess = false;
		});

		builder.addCase(getInstallationLocationList.fulfilled, (state, action) => {
			let statementList = action.payload;
			let statementListSelect = [];

			action.payload.map(item =>
				statementListSelect.push({
					item: item,
					value: item._id,
					label: item.name,
				})
			);

			state.itemInstallationLocationList = statementList;
			state.statementList = statementList;
			state.statementListSelect = statementListSelect;
			state.isLoadingList = false;
			state.isInstallationLocationSuccess = true;
		});

		builder.addCase(getInstallationLocationList.rejected, (state, action) => {
			state.error = action.payload || null;
			state.isLoadingList = false;
			state.isInstallationLocationSuccess = false;
		});

		builder.addCase(getInstallationLocation.pending, state => {
			state.isInstallationLocationLoading = true;
			state.isInstallationLocationSuccess = false;
		});

		builder.addCase(getInstallationLocation.fulfilled, (state, action) => {
			state.itemInstallationLocation = action.payload;
			state.isInstallationLocationLoading = false;
			state.isInstallationLocationSuccess = true;
		});

		builder.addCase(getInstallationLocation.rejected, (state, action) => {
			state.error = action.payload || null;
			state.isInstallationLocationLoading = false;
			state.isInstallationLocationSuccess = false;
		});

		builder.addCase(addNewInstallationLocation.pending, state => {
			state.isLoadingList = true;
			state.isAdding = true;
			state.isAdded = false;
			state.isAddError = false;
		});

		builder.addCase(addNewInstallationLocation.fulfilled, (state, action) => {
			state.itemInstallationLocationList.push(action.payload);
			state.statementList.push(action.payload);
			state.statementListSelect.push({
				item: action.payload,
				value: action.payload._id,
				label: action.payload.name,
			});
			state.isLoadingList = false;
			state.isAdding = false;
			state.isAdded = true;
			state.requireCloseModal = true;
		});

		builder.addCase(addNewInstallationLocation.rejected, (state, action) => {
			state.error = action.payload || null;
			state.isLoadingList = false;
			state.isAdding = false;
			state.isAddError = true;
		});

		builder.addCase(updateInstallationLocation.pending, state => {
			state.isLoadingList = true;
			state.isUpdating = true;
			state.isUpdated = false;
			state.isUpdateError = false;
		});

		builder.addCase(updateInstallationLocation.fulfilled, (state, action) => {
			state.itemInstallationLocationList = state.itemInstallationLocationList.map(
				installationLocationList =>
					installationLocationList._id.toString() === action.payload._id.toString()
						? { ...installationLocationList, ...action.payload }
						: installationLocationList
			);
			state.statementList = state.statementList.map(installationLocationList =>
				installationLocationList._id.toString() === action.payload._id.toString()
					? { ...installationLocationList, ...action.payload }
					: installationLocationList
			);
			state.statementListSelect = state.statementListSelect.map(item =>
				item.value.toString() === action.payload._id.toString()
					? {
							item: action.payload,
							value: action.payload._id,
							label: action.payload.name,
					  }
					: item
			);
			state.isLoadingList = false;
			state.isUpdating = false;
			state.isUpdated = true;
			state.requireCloseModal = true;
		});

		builder.addCase(updateInstallationLocation.rejected, (state, action) => {
			state.error = action.payload || null;
			state.isLoadingList = false;
			state.isUpdating = false;
			state.isUpdateError = true;
		});

		builder.addCase(deleteInstallationLocation.pending, state => {
			state.isLoadingList = true;
			state.isDeleting = true;
			state.isDeleted = false;
			state.isDeleteError = false;
		});

		builder.addCase(deleteInstallationLocation.fulfilled, (state, action) => {
			state.itemInstallationLocationList = current(
				state.itemInstallationLocationList
			).filter(item => item._id !== action.payload._id);
			state.statementList = current(state.statementList).filter(
				item => item._id !== action.payload._id
			);
			state.statementListSelect = current(state.statementListSelect).filter(
				item => item.value !== action.payload._id
			);
			state.isLoadingList = false;
			state.isDeleting = false;
			state.isDeleted = true;
			state.requireCloseModal = true;
		});

		builder.addCase(deleteInstallationLocation.rejected, (state, action) => {
			state.error = action.payload || null;
			state.isLoadingList = false;
			state.isDeleting = false;
			state.isDeleteError = true;
		});

		builder.addCase(checkInstallationLocationExists.pending, state => {
			state.exists = false;
		});

		builder.addCase(checkInstallationLocationExists.fulfilled, (state, action) => {
			state.exists = action.payload.exists;
		});

		builder.addCase(checkInstallationLocationExists.rejected, (state, action) => {
			state.exists = false;
		});
	},
});

export const { setRequireCloseModal } = InstallationLocationSlice.actions;

export default InstallationLocationSlice.reducer;
